import { logger, LogTag } from '@/config/logger'
import CircularProgress from '@mui/material/CircularProgress'
import { useState } from 'react'
import { ProcessingResult } from './ProcessingResult'
import './styles/homefileitem.css'

export interface FileItemProps {
  fileName?: string
  processingResult?: ProcessingResult
  handleDownloadResult?: (result: ProcessingResult) => Promise<void>
}

const FileItem = (props: FileItemProps) => {
  logger.debug(LogTag.HomePage, 'props:', props)
  const [isLoading, setLoading] = useState(false)

  async function handleDownload() {
    if (isLoading) {
      return
    }

    if (props.handleDownloadResult && props.processingResult) {
      setLoading(true)
      logger.debug(LogTag.HomePage, 'Start loading results...')
      await props.handleDownloadResult(props.processingResult)
      logger.debug(LogTag.HomePage, 'loading done.')
      setLoading(false)
    }
  }

  const DownloadComp = ({
    isLoading,
    handleDownload,
  }: {
    isLoading: boolean
    handleDownload: () => void
  }) => {
    return (
      <div className="download-comp">
        {isLoading ? (
          <CircularProgress size={20} sx={{ color: '#f67d69' }} />
        ) : (
          <button
            className="downloadButton"
            type="button"
            onClick={handleDownload}
          >
            Download
          </button>
        )}
      </div>
    )
  }
  return (
    <div className="file-item">
      <img src="/icon/file-type-icon.svg" alt="File type icon" />
      <div className="filename">{props.fileName}</div>
      {props.handleDownloadResult &&
        props.processingResult?.isResultDownloadAvailable() && (
          <DownloadComp isLoading={isLoading} handleDownload={handleDownload} />
        )}
    </div>
  )
}

export default FileItem
